export function txnsCookieKey(campaignId, userId) {
  return `${campaignId}-${userId}-txns`
}
